import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from './menu.service';
import { AccountRow } from '../utils/account-menu';

/** Ejecuta lo que pide una fila de cuenta. Lo comparten el sheet de cuenta y Mi cuenta. */
@Injectable({ providedIn: 'root' })
export class AccountActionsService {
  constructor(
    private readonly router: Router,
    private readonly menuService: MenuService,
  ) {}

  async run(row: AccountRow): Promise<void> {
    switch (row.action) {
      case 'logout':
        await this.menuService.logout();
        return;
      default:
        if (row.route) {
          await this.router.navigate([row.route]);
        }
    }
  }
}
